var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Head',{attrs:{"globalData":_vm.globalData}}),_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.path}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.$route.path}):_vm._e(),_c('Foot',{attrs:{"globalData":_vm.globalData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }